module.exports = __webpack_public_path__ + "static/img/SLAB_PVC.d3186f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/SLAB_PVC.jpg
// module id = KvKQ
// module chunks = 0